import React, { useEffect, useRef, useState } from "react";
import { Button } from "@progress/kendo-react-buttons";
import { Typography } from "@progress/kendo-react-common";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { LoadingPanel } from "../../components/layout/Loading";
import FormTextField from "../../components/formFields/FormTextField";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import { STATUSARRAY } from "../../_contstants/common";
import {
  createHowitworks,
  getAllHowitworks,
  getHowitworksByID,
  HowitworksImageUpload,
  updateHowitworks,
} from "./services/howitworks.services";
import { clearHowitworksDetails } from "./howitworksSlice";
import FormRichTextField from "../../components/formFields/FormRichTextField";
import { closed } from "../../components/muidrawer/muiDrawerSlice";
import { RxCross1 } from "react-icons/rx";
import FormImageUploadMorden from "../../components/formFields/formImageUploadMorden";

const CreateHowitworks: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);
  // const location = useLocation();
  // const HowitworksID = location.state?.HowitworksID;
  const HowitworksID = useAppSelector((state) => state.muidrawer.data);
  const HowitworksDetail = useAppSelector(
    (state) => state.howitworks.HowitworksDetail,
  );
  const loading = useAppSelector((state) => state.howitworks.formLoading);
  const [formKey, setFormKey] = useState(1);

  useEffect(() => {
    setFormKey(formKey + 1);
  }, [HowitworksDetail]);

  useEffect(() => {
    if (HowitworksID) {
      dispatch(getHowitworksByID(HowitworksID));
    }
    return () => {
      dispatch(clearHowitworksDetails());
    };
  }, [HowitworksID]);

  const handleSubmit = async (values: any) => {
    const formData = {
      Title: values.Title ? values.Title : "",
      Type: values.Type ? values.Type : "",
      ShortDescription: values.ShortDescription ? values.ShortDescription : "",
      SequenceNo: values.SequenceNo ? values.SequenceNo : 0,
      IsActive: values.IsActive === 1,
    };
    const ImageData = new FormData();
    const IconImage =
      values?.IconImage &&
      typeof values?.IconImage !== "string" &&
      Array.isArray(values?.IconImage) &&
      values?.IconImage?.length > 0
        ? values.IconImage[0].getRawFile()
        : "";
    const MainImage =
      values?.MainImage &&
      typeof values?.MainImage !== "string" &&
      Array.isArray(values?.MainImage) &&
      values?.MainImage?.length > 0
        ? values.MainImage[0].getRawFile()
        : "";

    try {
      if (HowitworksID) {
        const editPayload = {
          ...formData,
          ID: HowitworksID,
        };

        const response = await dispatch(updateHowitworks(editPayload));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(closed());

          if (
            (values?.IconImage &&
              typeof values?.IconImage !== "string" &&
              Array.isArray(values?.IconImage) &&
              values?.IconImage?.length > 0) ||
            (values?.MainImage &&
              typeof values?.MainImage !== "string" &&
              Array.isArray(values?.MainImage) &&
              values?.MainImage?.length > 0)
          ) {
            ImageData.append("IconImage", IconImage);
            ImageData.append("MainImage", MainImage);
            ImageData.append("ID", HowitworksID);
            await dispatch(HowitworksImageUpload(ImageData));
          }
          dispatch(getAllHowitworks());
          dispatch(clearHowitworksDetails());
        }
      } else {
        const response = await dispatch(createHowitworks(formData));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(closed());
          if (
            ((values?.IconImage &&
              typeof values?.IconImage !== "string" &&
              Array.isArray(values?.IconImage) &&
              values?.IconImage?.length > 0) ||
              (values?.MainImage &&
                typeof values?.MainImage !== "string" &&
                Array.isArray(values?.MainImage) &&
                values?.MainImage?.length > 0)) &&
            response?.payload?.Data?.ID
          ) {
            ImageData.append("IconImage", IconImage);
            ImageData.append("MainImage", MainImage);
            ImageData.append("ID", response?.payload?.Data?.ID);
            await dispatch(HowitworksImageUpload(ImageData));
          }
          dispatch(getAllHowitworks());
          dispatch(clearHowitworksDetails());
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  // if (loading) return <LoadingPanel gridRef={gridRef} />;
  return (
    <>
      <div className="relative">
        {loading && <LoadingPanel gridRef={gridRef} />}
        <Form
          key={formKey}
          onSubmit={handleSubmit}
          initialValues={HowitworksDetail}
          render={(formRenderProps: FormRenderProps) => (
            <FormElement>
              <GridLayout
                style={{ marginRight: 12 }}
                gap={{ rows: 10, cols: 10 }}
                cols={[{ width: "33%" }, { width: "33%" }, { width: "33%" }]}
              >
                <GridLayoutItem colSpan={3} className="master-drawer-header">
                  <Typography.h4 className="m-0">
                    {HowitworksID
                      ? "Update How it works"
                      : "Create How it works"}
                  </Typography.h4>
                  <Button
                    type="button"
                    fillMode={"flat"}
                    themeColor={"dark"}
                    style={{ marginRight: 4 }}
                    onClick={() => dispatch(closed())}
                  >
                    <RxCross1 />
                  </Button>
                </GridLayoutItem>
                <GridLayoutItem colSpan={3} style={{ width: "100%" }}>
                  <Field
                    name="Title"
                    label="Title"
                    placeholder="Title"
                    component={FormTextField}
                    validator={requiredValidator}
                    astrike={true}
                  />
                </GridLayoutItem>
                <GridLayoutItem colSpan={3} style={{ width: "100%" }}>
                  <Field
                    name="ShortDescription"
                    label="Short Description"
                    component={FormRichTextField}
                    validator={requiredValidator}
                    astrike={true}
                  />
                </GridLayoutItem>
                <GridLayoutItem colSpan={2} style={{ width: "100%" }}>
                  <Field
                    justifyContent="start"
                    name={`MainImage`}
                    label="Main Image"
                    type="file"
                    accept="image/*"
                    alternateName="Main Image"
                    component={FormImageUploadMorden}
                  />
                </GridLayoutItem>
                <GridLayoutItem style={{ width: "100%" }}>
                  <Field
                    justifyContent="start"
                    name={`IconImage`}
                    label="Icon Image"
                    type="file"
                    accept="image/*"
                    alternateName="Icon Image"
                    component={FormImageUploadMorden}
                  />
                </GridLayoutItem>
                <GridLayoutItem style={{ width: "100%" }}>
                  <Field
                    name={`Type`}
                    label="Type"
                    component={FormSelectionField}
                    validator={requiredValidator}
                    astrike={true}
                    options={[
                      { label: "Home", value: "Home" },
                      { label: "Retailer", value: "Retailer" },
                    ]}
                  />
                </GridLayoutItem>
                <GridLayoutItem style={{ width: "100%" }}>
                  <Field
                    name="SequenceNo"
                    label="Sequence No"
                    placeholder="i.e. 1, 2"
                    type="number"
                    component={FormTextField}
                    validator={requiredValidator}
                    astrike={true}
                  />
                </GridLayoutItem>
                <GridLayoutItem style={{ width: "100%" }}>
                  <Field
                    name={`IsActive`}
                    label="Status"
                    component={FormSelectionField}
                    validator={requiredValidator}
                    astrike={true}
                    options={STATUSARRAY?.map((status: any) => {
                      return {
                        value: status?.value,
                        label: status?.label,
                      };
                    })}
                  />
                </GridLayoutItem>
                <GridLayoutItem
                  colSpan={3}
                  style={{
                    marginTop: "20px",
                    display: "flex",
                    justifyContent: "end",
                    alignItems: "end",
                  }}
                >
                  <div>
                    <ButtonWithLoading
                      label={HowitworksID ? "Update" : "Create"}
                      type="submit"
                      disabled={!formRenderProps.allowSubmit || loading}
                      loading={loading}
                    />
                    <Button
                      type="button"
                      fillMode={"outline"}
                      themeColor={"secondary"}
                      style={{ marginLeft: 10 }}
                      onClick={() => dispatch(closed())}
                    >
                      Cancel
                    </Button>
                  </div>
                </GridLayoutItem>
              </GridLayout>
            </FormElement>
          )}
        />
      </div>
    </>
  );
};

export default CreateHowitworks;
